import { render, staticRenderFns } from "./AppointmentProps.vue?vue&type=template&id=47cbcb38&scoped=true&"
import script from "./AppointmentProps.vue?vue&type=script&lang=js&"
export * from "./AppointmentProps.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentProps.vue?vue&type=style&index=0&id=47cbcb38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbcb38",
  null
  
)

export default component.exports